import React from "react";

interface ToggleSwitchProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  id?: string;
  labelOn?: string;
  labelOff?: string;
}

const ToggleSwitch = ({
  checked,
  onCheckedChange,
  id,
  labelOn = "On",
  labelOff = "Off",
}: ToggleSwitchProps) => {
  return (
    <div className="flex items-center gap-2">
      <button
        role="switch"
        aria-checked={checked}
        id={id}
        onClick={() => onCheckedChange(!checked)}
        className={`
          relative inline-flex h-5 w-9 items-center rounded-full
          transition-colors focus-visible:outline-none focus-visible:ring-2
          focus-visible:ring-offset-1 focus-visible:ring-offset-white
          ${checked ? "bg-primary-600" : "bg-gray-200"}
        `}
      >
        <span
          className={`
            inline-block h-4 w-4 transform rounded-full bg-white shadow-lg
            transition-transform
            ${checked ? "translate-x-4" : "translate-x-0.5"}
          `}
        />
      </button>
      <span className="text-sm font-medium">
        {checked ? labelOn : labelOff}
      </span>
    </div>
  );
};

export default ToggleSwitch;
